<template>
  <transition name="fade">
    <div id="message" class="message" v-show="!visible">
      {{ message }}
    </div>
  </transition>
</template>

<script>
export default {
  name: "Message",
  data() {
    return {
      visible: true,
      message: "",
      time: 1500
    };
  },
  methods: {
    show() {
      this.visible = false;
      this.timer = setTimeout(() => {
        this.hide();
      }, this.time);
    },
    hide() {
      this.visible = true;
      clearTimeout(this.timer);
      this.$emit("closed");
    }
  }
};
</script>

<style lang="less" scoped>
.message {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 10000;
  font-size: 1.8rem;
  color: #fff;
  width: 150px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  background: rgba(0, 0, 0, 0.8);
}
</style>



// WEBPACK FOOTER //
// src/components/message/message.vue